module.exports = __webpack_public_path__ + "static/media/before_n_after_d.258367b2.jpg";